import { useFormikContext } from 'formik';
import InternationalTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

export default function IntlTelInput({name, text, preferredCountries}:{name:string, text:string, preferredCountries: string[]}) {

    const {setFieldValue, setFieldTouched, values, errors, touched} = useFormikContext<any>()
    
    return (

        <div className='duration-300'>

            <label htmlFor={name} className="flex flex-row text-left justify-between font-medium text-graphite_x2 mb-0.3">
                {text}
                {(errors[name] && touched[name]) && <span className="w-2 h-2 bg-error rounded-full inline-block"/>}
            </label>

            {/* @ts-ignore */}
            <InternationalTelInput
                containerClassName="intl-tel-input w-full"
                inputClassName="form-control bg-secondary2 border-none block w-full py-4 px-3 rounded-0.3 outline-none capitalize focus:bg-primary focus:text-light_col relative"
                onPhoneNumberChange={(isValid,value, ii, fullNumber)=>{
                    setFieldValue(name, fullNumber)
                }}
                onPhoneNumberBlur={()=>{setFieldTouched(name)}}
                value={values[name]}
                preferredCountries={preferredCountries}
            />
            
        </div>
        
    );

}
